angular.module('elfium').controller('businessCaseListItemDetailController', ['$scope', '$element', 'taskService', 'taskSplitByTypeFilter', 'elfiumToastrService', 'TASK_TYPES',
    function ($scope, $element, taskService, taskSplitByTypeFilter, elfiumToastrService, TASK_TYPES) {
        var that = this;
        that.numberOfColumns = 8;
        that.refreshTasks = function () {
            $scope.tasks = taskSplitByTypeFilter($scope.businessCaseListItem.tasks);
        };
        that.getColumnWidths = function () {
            var widths = [];
            var detailElement = $element.next().find('.business-case-detail');
            if (detailElement.length) {
                for (var i = 0; i < that.numberOfColumns; ++i) {
                    widths.push(detailElement.find('th:nth-of-type(' + (i + 1) + ')').css('width'));
                } 
            }
            return widths;
        };
        that.updateColumnWidths = function (columnWidths) {
            if (columnWidths.length) {
                for (var i = 0; i < that.numberOfColumns; ++i) {
                    $('.business-case-detail th:nth-of-type(' + (i + 1) + ')').css('width', columnWidths[i]);
                }
            }
        };
        that.reloadBusinessCase = function () {
            $scope.$emit('reloadBusinessCase', $scope.businessCaseListItem.id);
        };
        $scope.getKOtevreniTasks = function () {
            return $scope.tasks[TASK_TYPES.KOTEVRENI];
        };
        $scope.getPotrebaTasks = function () {
            return $scope.tasks[TASK_TYPES.POTREBA];
        };
        $scope.getNabidkaTasks = function () {
            return $scope.tasks[TASK_TYPES.NABIDKA];
        };
        $scope.getKUzavreniTasks = function () {
            return $scope.tasks[TASK_TYPES.KUZAVRENI];
        };
        $scope.openTaskDetailModal = function (taskId) {
            taskService.openTaskDetailModal(taskId).then(that.reloadBusinessCase);
        };
        $scope.$watchCollection('businessCaseListItem', function (newValue) {
            if (newValue) {
                that.refreshTasks();
            }
        });
        $scope.$watchCollection(that.getColumnWidths, that.updateColumnWidths);
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/businessCase/businessCaseListItemDetailController.ts